import React, { useState } from "react";
import Quiz from "../Quiz/Quiz";
import "../../styles/QuizTrigger/QuizTrigger.css";
export default function QuizTrigger() {
  const [isQuizOpen, setIsQuizOpen] = useState(false);

  return (
    <>
      <button className="quiz-trigger-btn" onClick={() => setIsQuizOpen(true)}>
        Take the quiz now
      </button>
      <Quiz isOpen={isQuizOpen} onClose={() => setIsQuizOpen(false)} />
    </>
  );
}
